import React from 'react';
import { useLocation } from 'react-router-dom';
import { getQueryParams } from '../../services/UtilityService';
import AssessmentService from '../../services/TTGAssessmentService';
import Report from "./Report";

const TTGReport = () => {
    const location = useLocation();
    const params = getQueryParams(location.search);
    const { child } = AssessmentService.getReportData(params);

    if (!child) {
        return <p>loading</p>;
    }

    return <Report details={child} />;
};

export default TTGReport;
